import { Player } from 'types/global'
import ProfilePanel from '../generic/profile-panel/ProfilePanel'
import PlayerLevelTable from './player-level-table/PlayerLevelTable'
import BlurredPlayerLevel from '../locked-panels/BlurredPlayerLevel'
import PlayerLevelTooltip from './player-level-tooltip/PlayerLevelTooltip'

interface Props {
  profile: Player
  isLoggedIn?: boolean
}

const PlayerLevel = ({ profile, isLoggedIn }: Props) => {
  return (
    <ProfilePanel title={<PlayerLevelTooltip />}>
      {isLoggedIn ? <PlayerLevelTable profile={profile} /> : <BlurredPlayerLevel />}
    </ProfilePanel>
  )
}

export default PlayerLevel
